import React from 'react';
import GetSvg from '../../vendor/GetSvg';
import getCategoryIcon from './categoryIcons';

const NONE = '—';

const FavouriteStats = ({ category, brand }) => (
  <div className="favourite-stats">
    <div className="favourite-stats__heading">
      Favourite
      <br />
      Category
    </div>
    <div className="favourite-stats__heading">
      Favourite
      <br />
      Brand
    </div>

    <div className="favourite-stats__value">
      {category ? (
        <GetSvg
          svg={getCategoryIcon(category)}
          wrapperClass="svg favourite-stats__icon"
        />
      ) : (
        NONE
      )}
    </div>
    <div className="favourite-stats__value favourite-stats__brand">
      {brand?.name || NONE}
    </div>
  </div>
);

export default FavouriteStats;
